import React from 'react';

import {
  Typography,
  TableFooter,
  Table,
  TableCell,
  TableBody,
  TableHead,
  TableRow,
  TableContainer,
  styled,
  Stack,
} from '@gogame/components';
import { NumberValueFormatter } from '@gogame/intl-ts';

const BoldCell = styled(TableCell)`
  font-weight: bold;
`;

const ConditionalRewardsTable = ({ data }) => {
  return (
    <TableContainer>
      <Table width={'100%'}>
        <TableHead>
          <TableRow>
            <TableCell col={'condition'} width={'35%'}>
              Condition
            </TableCell>
            <TableCell col={'reward'} width={'45%'}>
              Reward
            </TableCell>
            <TableCell col={'usersReached'} width={'20%'} align={'right'}>
              Users Reached
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.conditionalRewardsBreakdown?.breakdown.map((item, i) => (
            <TableRow key={i}>
              <TableCell col={'condition'}>
                <Stack>
                  <span>
                    {item.typeName} {item?.value}
                  </span>
                  {item.timer > 0 ? (
                    <Typography
                      variant={'caption'}
                      fontSize={12}
                      sx={{ color: 'text.secondary' }}
                    >
                      {`${item.timer} days for completion`}
                    </Typography>
                  ) : null}
                </Stack>
              </TableCell>
              <TableCell col={'reward'}>
                {item?.rewards.map((reward, index, arr) => {
                  const isLast = index === arr.length - 1;

                  return (
                    <span key={i}>
                      <NumberValueFormatter.Decimal value={reward.value} />{' '}
                      {reward.name}
                      {!isLast && ', '}
                    </span>
                  );
                })}
              </TableCell>

              <TableCell col={'usersReached'} align={'right'}>
                <Stack>
                  <span>{item.usersReached} </span>
                  <Typography
                    variant={'caption'}
                    fontSize={12}
                    sx={{ color: 'text.secondary' }}
                  >
                    <NumberValueFormatter.Percent
                      value={item.usersReachedPercent}
                    />
                  </Typography>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter width={'100%'}>
          <TableRow>
            <BoldCell colSpan={2}>Total</BoldCell>

            <BoldCell align={'right'}>
              <NumberValueFormatter.Decimal
                value={data?.conditionalRewardsBreakdown?.total}
              />
            </BoldCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default ConditionalRewardsTable;
